<template>
  <div class="page border-box" v-wechat-title="$route.meta.title='拼团'">
    <div class="desc bgF border-box" v-if="order&&order.protype==2&&order.order_state==12&&order.type==3">
      <div class="state tc">
        <p class="t cor3">拼团中</p>
        <p class="b cor-p"><font v-if="order.num - order.people>0">还差{{order.num - order.people}}人成团，</font>剩余时间 {{countTimeTxt}}</p>
      </div>
      <div class="tx-box border-box">
        <span v-for="(item,index) in peoples" :key="item.name">
          <img class="img" :src="item.headimg" alt="">
        </span>
        <span v-for="(item,index) in nopeople"><img src="../../assets/icon-tx.png" alt=""></span>
      </div>

      <div class="info">
        <div class="box">
          <div class="tit cor6">景区名称</div>
          <div class="flex cor-a" style="text-decoration: underline;"  @click="toHome">{{order.scenicName}}</div>
        </div>
        <div class="box">
          <div class="tit cor6">讲解服务</div>
          <div class="flex cor3">{{order.name}} <font v-if="order.protype==2"> ({{order.num}}人团)</font></div>
        </div>
        <div class="box">
          <div class="tit cor6">预约时间</div>
          <div class="flex cor3">{{order.time}} {{order.stime}}-{{order.etime}}</div>
        </div>
        <div class="box">
          <div class="tit cor6">拼团价</div>
          <div class="flex cor3">￥{{order.sellprice}}</div>
        </div>
      </div>

      <div class="btn linear" @click="toOrderCreat">参与拼团</div>
      <!--<div class="btn disabled">拼团已结束</div>-->

    </div>
    <div class="desc bgF border-box" v-else>
      <div class="state tc">
        <p class="t cor3">已结束</p>
        <p class="b cor-p">该拼团已结束，去看看别的预约产品吧</p>
      </div>

      <div class="btn linear" @click="toHome" style="margin-top: .3rem;">去往首页</div>
      <div class="btn linear" @click="toOrder" style="margin-top: .3rem;">我的订单</div>
      <!--<div class="btn disabled">拼团已结束</div>-->

    </div>


    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>
  </div>

</template>
<script>
  import P400 from '../../components/P400'
  import {pinOrderDetail} from "@/service/getData";
  import {wxGetPosition,wxShareme, wxOpenMapLocation, creatDSOrder,payMoney} from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'
  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return {
        userInfo: {}, //用户信息
        scenicId: this.$route.query.scenicId || '', //景区id
        scenicKey: this.$route.query.scenicKey || '', //来源标记
        ordernum: this.$route.query.ordernum || '', //订单编码
        order: '', //订单详情
        peoples: [], //拼团数据
        nopeople: [], //缺的人数数据

        P400: 0, //系统维护中

        countTimeTxt: '00:00:00',//倒计时
      }
    },
    created(){
      this.$loading.show('数据加载中');
      this.userInfo = getStore("userInfo");
      this.pinOrderDetailFun();
    },
    methods: {
      //获取订单详情数据
      async pinOrderDetailFun(){
        let res = await pinOrderDetail({
          ordernum: this.ordernum,
          time: (new Date().getTime())
        });
        this.$loading.hide();
        if (res.errcode == "00000") {
          this.order = res.data

          if(this.order.protype==2&&this.order.order_state==12&&this.order.type==3){
            this.countTime(this.order.mins);
          }

          var peoples = res.data.peoples, arr = [];
          if(peoples && peoples.length>0){
            for(var i=0; i<peoples.length; i++){
              var item = peoples[i];
              if(item.buynum > 1){
                for(var j=0; j<item.buynum; j++){
                  arr.push(item)
                }
              }else {
                arr.push(item)
              }
            }
          }
          this.peoples = arr;

          var num = res.data.num - res.data.people,arr1 = [];
          for(var i=0; i<num; i++){
            arr1.push({})
          }
          this.nopeople = arr1;


          let title = res.data.name + '| 导游预约';
          let desc = '欢迎使用导游预约服务系统，快来和我一起拼团吧';
          let link = '/order-share?ordernum='+this.ordernum+'&scenicId='+this.scenicId+'&scenicKey='+this.scenicKey
          wxShareme(title, desc, '', link);


        }else {
          this.$toast(res.errmsg);
        }
      },


      //倒计时
      countTime: function(etime) {
        //获取当前时间
        var date = new Date();
        var ntime = date.getTime();

        var str = etime;
        if (etime) {
          if (typeof etime === 'string') {
            str = new Date(etime.replace(/-/g, "/"));
          } else if (typeof etime === 'number') {
            str = new Date(etime);
          }
        }
        etime = (new Date(str)).getTime();
        //时间差
        var leftTime = etime-ntime;
        if(leftTime <= 0){  //时间已过
          if(this.order.order_state==10){ //待支付
            this.order.order_state=13
          }else {
            this.order.type=9
          }
        }else {
          //定义变量 d,h,m,s保存倒计时的时间
          var d,h,m,s;
          if (leftTime>=0) {
            d = Math.floor(leftTime/1000/60/60/24);
            h = Math.floor(leftTime/1000/60/60%24);
            m = Math.floor(leftTime/1000/60%60);
            s = Math.floor(leftTime/1000%60);
            h = h>9?h:'0'+h;
            m = m>9?m:'0'+m;
            s = s>9?s:'0'+s;
          }

          var txt = '';
          if(d>0){
            txt = d+"天 "+h+":"+m+":"+s;
          }else {
            txt = h+":"+m+":"+s;
          }
          this.countTimeTxt = txt;

          //递归每秒调用countTime方法，显示动态时间效果
          var self = this;
          setTimeout(function(){
            self.countTime(etime)
          },1000);
        }

      },

      //跳转至创建订单页面
      toOrderCreat:function(){
        this.$router.push({
          path: `/order-create?${'ordernum1='+this.order.ordernum2+'&scenicId='+this.scenicId+'&scenicKey='+this.scenicKey}`
        });
      },

      //跳转至景区首页
      toHome:function(){
        var id = (this.order&&this.order.scenicId)?this.order.scenicId:'';
        this.$router.replace({
          path: `/?scenicId=`+id+'&scenicKey='+this.scenicKey
        });
      },

      //跳转到订单页面
      toOrder:function(){
        var id = (this.order&&this.order.scenicId)?this.order.scenicId:'';
        this.$router.push({
          path: `/order-list?scenicId=`+id+'&scenicKey='+this.scenicKey
        });
      },



    },
    watch: {},
    components: {
        P400
    },
  }

</script>

<style scoped>
  @import "../../style/alert.css";
  .page{min-height:100vh;padding: .3rem .3rem 1.2rem;background-color:#f2f2f2}
  .desc{border-radius: .12rem;padding: 0 .3rem .4rem;}
  .state{padding: .5rem 0 .4rem;border-bottom: 1px solid #e3e3e3;}
  .state .t{font: bold .36rem "Microsoft YaHei";}
  .state .b{margin-top: .24rem;font: .26rem "Microsoft YaHei";}
  .info{ padding-top: .3rem;padding-bottom: .2rem; color: #333;}
  .info .box{padding: .2rem 0;font: .28rem/.48rem "Microsoft YaHei";}
  .info .box .tit{width: 1.6rem;}
  .tx-box{padding: .17rem 0 .4rem;border-bottom: 1px solid #e3e3e3;}
  .tx-box span{position:relative;display: inline-block;width: .96rem;height: .96rem;margin:.2rem .01rem 0;vertical-align:top;border-radius: 50%;border: 1px solid #e3e3e3;}
  .tx-box span img{width: 100%;height: 100%;object-fit:cover;border-radius: 50%;overflow: hidden;}
  .tx-box span i{position: absolute; left: 50%; bottom: -.14rem; width: .64rem; height: .34rem; margin-left: -.32rem;color:#ffb500;text-align: center;font-style: normal;}
  .tx-box span:first-child i{display:none;}
  .tx-box span:before{content: '';position: absolute;top:0;left: 0;right:0;bottom:0;border: .03rem solid #efefef;border-radius: 50%;}
  .tx-box span:last-child:before{display: none;}
  .tx-box span:first-child:before{content: '';position: absolute;top:0;left: 0;right:0;bottom:0;border: .03rem solid #ffb500;border-radius: 50%;}
  .tx-box span:first-child:after{content: '';position: absolute;left: 50%;bottom:-.1rem;width: .64rem;height: .34rem;margin-left:-.32rem;background: url(../../assets/icon-tz.png) no-repeat center;background-size: 100% auto;}
  .btn{height: .8rem;font: .36rem/.8rem "Microsoft YaHei";}

</style>



// WEBPACK FOOTER //
// src/page/home/order-share.vue